import React, { useState, useEffect } from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

interface OfflineIndicatorProps {
  className?: string;
}

const OfflineIndicator: React.FC<OfflineIndicatorProps> = ({ className = '' }) => {
  const { isOnline, isOffline, wasOffline } = useOnlineStatus();
  const [showReconnectedMessage, setShowReconnectedMessage] = useState(false);

  useEffect(() => {
    if (wasOffline) {
      setShowReconnectedMessage(true);
      const timer = setTimeout(() => {
        setShowReconnectedMessage(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [wasOffline]);

  if (isOnline && !showReconnectedMessage) {
    return null;
  }

  if (showReconnectedMessage) {
    return (
      <div className={`offline-indicator ${className}`}>
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#10b981',
          color: 'white',
          padding: '12px 24px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          animation: 'slideDown 0.3s ease-out'
        }}>
          <span>✅</span>
          <span>Conexão restaurada! Você está online novamente.</span>
          <button
            onClick={() => setShowReconnectedMessage(false)}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '16px',
              cursor: 'pointer',
              marginLeft: '8px'
            }}
          >
            ×
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`offline-indicator ${className}`}>
      <div style={{
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        backgroundColor: '#ef4444',
        color: 'white',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        textAlign: 'center',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px'
      }}>
        <span>📡</span>
        <span>Sem conexão com a internet. Algumas funcionalidades podem estar limitadas.</span>
      </div>
      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-100%);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default OfflineIndicator;